import {Box, Show} from 'platform/foundation';

import {useState} from 'react';

import {GetVehicleApiResponse, useLazyGetVehicleQuery} from '@dms/api/vehicle';
import {handleApiError} from '@dms/shared';

import {CalendarForm} from './TestDriveSelectVehicle/CalendarForm';
import {VehicleForm} from './TestDriveSelectVehicle/VehicleForm';

interface TestDriveSelectVehicleDialogProps {
  onTestDriveSelect: (data: {vehicleId: string; start: Date; end: Date}) => void;
  defaultActiveTab?: 'list' | 'calendar';
  defaultVehicle?: GetVehicleApiResponse | null;
}

export function TestDriveSelectVehicleDialog(props: TestDriveSelectVehicleDialogProps) {
  const [activeTab, setActiveTab] = useState<'list' | 'calendar'>(props.defaultActiveTab ?? 'list');
  const [selectedVehicle, setSelectedVehicle] = useState<GetVehicleApiResponse | null>(
    props.defaultVehicle ?? null
  );

  const [getVehicle] = useLazyGetVehicleQuery();

  const onVehicleSelect = async (vehicleId: string) => {
    const vehicle = (await getVehicle({vehicleId})
      .unwrap()
      .catch(handleApiError)) as GetVehicleApiResponse;
    setSelectedVehicle(vehicle);
    setActiveTab('calendar');
  };

  const handleChangeVehicle = () => {
    setActiveTab('list');
  };

  const handleConfirm = (data: {vehicleId: string; start: Date; end: Date}) => {
    props.onTestDriveSelect(data);
  };

  const handleDiscard = () => {
    setActiveTab('list');
    setSelectedVehicle(null);
  };

  return (
    <Box>
      <Show when={activeTab === 'list'}>
        <VehicleForm onVehicleSelect={onVehicleSelect} />
      </Show>

      <Show when={activeTab === 'calendar'}>
        {selectedVehicle && (
          <CalendarForm
            vehicle={selectedVehicle}
            onConfirm={handleConfirm}
            onDiscard={handleDiscard}
            onChangeVehicle={handleChangeVehicle}
          />
        )}
      </Show>
    </Box>
  );
}
